import Axios from 'axios';
import PortalVue from 'portal-vue';
import Vue from 'vue';

Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;

Vue.config.productionTip = false
Vue.prototype.$http = Axios;

Vue.use(PortalVue);

import Alert from './components/Alert';
import EartagApp from './App';
import Modal from './components/Modal';
import SvgSpinner from './components/SvgSpinner';

new Vue({
  components: {
    Alert,
    EartagApp,
    Modal,
    SvgSpinner,
  },

  data: () => ({
    alertMsg: '',
    alertVisible: false,
    imageDomain: 'https://d304rnvtcwdb48.cloudfront.net/',
    isModalOpen: false,
    prodId: null,
    initialState: {},
    sending: false,
    storedPreview: null,
  }),

  methods: {
    async addToCart(props, e) {
      let data = props.data;

      this.resetAlert();

      this.sending = true;

      data.properties[0].eartag.preview = await this.storePreview(props.preview, this.storedPreview);

      await this.$http.post('/cart/add', data)
        .then(response => {
          // window.location.href = '/cart';

          window.addToCartSuccessModal(response.data);

          this.$refs['eartag-app'].resetState();

          this.storedPreview = null;
        })
        .catch(error => {
          this.alertMsg = error.response.data;
          this.alertVisible = true;
        })
        .then(() => {
          this.sending = false;
        });
    },

    closeAndReset() {
      this.prodId = null;

      this.initialState = {};

      this.storedPreview = null;

      this.isModalOpen = false;

      this.resetAlert();
    },

    editTag(item) {

      this.prodId = item.purchasable.parent_id;

      this.initialState = {
        sku: item.sku,
        quantity: item.qty,
        properties: (item.properties || {}).eartag || {},
      };

      this.storedPreview = this.initialState.properties.preview || null;

      this.isModalOpen = true;
    },

    resetAlert() {
      this.alertMsg = '';
      this.alertVisible = false;
    },

    async storePreview(preview, filename) {
      const { data: response } = await this.$http.post('/eartag/preview', {
        base64Data: preview,
        filename: filename,
      });

      this.storedPreview = response.filename;

      return response.filename;
    },

    async updateCartItem(props, e) {
      let data = props.data;

      this.resetAlert();

      this.sending = true;

      data.properties[0].eartag.preview = this.storedPreview;

      await this.$http.post('/cart/update-row', data)
        .then(async (response) => {
          await this.storePreview(props.preview, this.storedPreview);
        }).then(response => {
          window.location.reload();
        }).catch(error => {
          this.alertMsg = error.response.data;
          this.alertVisible = true;

          this.sending = false;
        });
    },
  },
}).$mount('#'+(document.getElementById('eartag-app') ? 'eartag-app' : 'global-wrapper'));
